<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="290" overlay-opacity="0.8">
      <v-card v-if="!loading" :style="{ 'background-color': welcomeBGColor }" style="margin:0px; padding:0px">
        <v-card-text style="padding: 0;">
          <!--div style="width:100%;text-align: right;padding: 0 40px">
            <button 
            style="margin-right:-30px;margin-top:-10px;"
              @click="dialog = false"
            >
              <v-icon
                style="margin-left: 0px; color: white;font-size:30px;"
                :style="{ 'color': welcomeColor }"
                class="activity-button"
              >
                mdi-close
              </v-icon>
            </button>
          </div-->
          <v-btn
                  v-show="!hidden"
                  :color="welcomeBGColor"
                  @click="dialog = false"
                  fab
                  dark
                  x-small
                  absolute
                  top
                  right
                  style="top: 6px;right:8px;"
                  elevation="0"
                >
                  <v-icon
                    :style="{ 'color': welcomeColor }"
                  >
                  mdi-close</v-icon>
                </v-btn>
          <center>
            <v-img 
              v-if="image"
              :src="image" :lazy-src="image" 
                  @click="dialog = false"
              />
          </center>
          <center style="margin-bottom: 20px;" v-if="icon && icon.length > 0 && icon !== '6'">
            <button 
              disabled="true"
              style="border-radius:50%; height:55px; width:55px; text-align:center; padding:5px 5px 10px 5px; opacity:0.7;"
              :style="{ 'background-color': welcomeColor}"
            >
              <v-icon
                style="margin-left: 0px; color: white;font-size:35px;"
                dark
                class="activity-button"
                :style="{ 'color': welcomeBGColor}"
              >
                {{icon}}
              </v-icon>
            </button>
          </center>
          <div style="padding: 10px" class="result-html">
            <vue-editor 
              v-model="messageLocale"
              :disabled="true"
              :editor-toolbar="aux"
              :style="{ 'color': `${welcomeColor} !important`, 'font-size': `500px !important` }"
            />
          </div>
          <count-down v-if="countDown" :countDown="countDown" :bgcolor="welcomeBGColor" />
          <div
              v-if="withButton"
              style="padding: 20px;"
            >
            <v-btn 
              block
              :color="welcomeColor"
              @click="handleOpenButtonwindow"
            >
            <span :style="{ color: welcomeBGColor  }">
              {{buttonText}}
            </span>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import { mapState } from 'vuex'
  import { VueEditor } from "vue2-editor"
  import api from '@/services/api'
  import utils from '@/services/utils'
  import CountDown from './CountDown'
  export default {
    components: {
      VueEditor,
      CountDown
    },
    props: {
      data: {
        type: Object,
        required: true
      },
      previewData: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        hidden: null,
        dialog: false,
        loading: true,
        icon: this.data.Icon,
        message: null,
        messageLocale: null,
        welcomeBGColor: null,
        welcomeColor: null,
        aux: [[],[],[],[],[],[],[],[],[],[],[],[],[{  }],[]],
        countDown: null,
        withButton: false,
        buttonText: null,
        buttonLink: null,
      }
    },
    computed: {
      ...mapState('app',['locale','BGColor', 'FontContent', 'FontSizeContent', 'ColorContent']),
      btnBackgroundColor () {        
        return this.$store.state.app.btnBackgroundColor && this.$store.state.app.btnBackgroundColor !== '' ? this.$store.state.app.btnBackgroundColor : this.BGColor
      },
      btnTextColor () {
        return this.$store.state.app.btnTextColor && this.$store.state.app.btnTextColor !== '' ? this.$store.state.app.btnTextColor : 'white'
      },
      foodDrinkTextColor () {
        return this.$store.state.app.foodDrinkTextColor && this.$store.state.app.foodDrinkTextColor !== '' ? this.$store.state.app.foodDrinkTextColor : this.ColorContent
      },
    },
    watch: {
      locale (newValue) {
        this.messageLocale = utils.getTranslation (this.message, newValue) 
        this.buttonText = this.data.ButtonText ? utils.getTranslation(JSON.parse(this.data.ButtonText), newValue) : ''
        this.buttonLink = this.data.ButtonLink ? utils.getTranslation(JSON.parse(this.data.ButtonLink), newValue) : ''
      },
      data (v){
        if(this.previewData) {
          this.getModalData(this.previewData.locale)
          if(!this.dialog) this.dialog = true
        }
      },
    },
    mounted () {
      this.getModalData()
    },
    methods: {
      getModalData (previewLocale) {
        this.icon = this.data.Icon
        this.message = this.data.Message ? JSON.parse(this.data.Message) : ''
        this.messageLocale = this.data.Message ? utils.getTranslation(JSON.parse(this.data.Message), previewLocale ? previewLocale : this.locale) : ''
        this.welcomeBGColor = this.data.BGColor
        this.welcomeColor = this.data.Color
        this.image = this.data.Image
        this.dialog = true
        this.loading = false
        this.countDown = this.data.IsCountDown && this.data.CountDown ? this.data.CountDown : null
        this.withButton = this.data.WithButton === 1
        this.buttonText = this.data.ButtonText ? utils.getTranslation(JSON.parse(this.data.ButtonText), previewLocale ? previewLocale : this.locale) : ''
        this.buttonLink = this.data.ButtonLink ? utils.getTranslation(JSON.parse(this.data.ButtonLink), previewLocale ? previewLocale : this.locale) : ''

      },
      handleOpenButtonwindow () {
        api.setStatsWelcomeModal('stats-welcome-modal', this.data.ID)
          .then(response => {
            //window.open(this.buttonLink, '_blank')
            window.location = this.buttonLink
            this.dialog = false
          })
          .catch(error => {
            console.log('error', error)
            //window.open(this.buttonLink, '_blank')
            window.location = this.buttonLink
            this.dialog = false
          })
        //window.open(this.buttonLink, '_blank')
      }
    }
  }
</script>

<style scoped>
  .modal-allergens {
    background-color: rgba(241, 241, 241);
  }
  .ql-editor p {
    font-size: var(--FontSizeContent);
  }
  .result-html .ql-toolbar.ql-snow {
    height: 0px !important;
    padding: 0px !important;
    border: 0px !important;
  }
  .result-html .ql-container.ql-snow {
    border: 0px !important;
  }
  .result-html .ql-editor {
    min-height: 0px !important;
  }   
</style>

